export const experienceData = [
    {
        id: 1,
        company: 'Fyn Mobility',
        jobtitle: 'Full Stack Developer',
        startYear: '2024',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Neebal Technologies',
        jobtitle: 'Software Engineer',
        startYear: '2022',
        endYear: '2024'
    },

]